// index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './AuthContext';
import { NovaNetworkLoader } from './components/ui/NovaLoader'; // Assurez-vous du bon chemin
import reportWebVitals from './reportWebVitals';
import './CSS/NovaForms.css';
import './CSS/NovaResponsive.css';
import './CSS/NovaCraForms.css';
import NovaRouteBodyClass from './components/ui/NovaRouteBodyClass';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <NovaNetworkLoader />
      <NovaRouteBodyClass />
      <App />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
